"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeDTO = exports.StoreDTO = exports.StorageFlushDTO = exports.RankingDTO = exports.ProductionCompleteDTO = exports.HarvestCompleteDTO = exports.CraftRequestDTO = exports.CraftCompleteDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const enum_1 = require("../types/enum");
const utility_1 = require("../decorators/utility");
const gal_reporting_groups_1 = require("../types/gal-reporting-groups");
const game_related_1 = require("../types/game-related");
let CraftCompleteDTO = class CraftCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.CraftCompleteDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "building", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recipe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "proximityEffects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of building where item is crafted'),
    __metadata("design:type", String)
], CraftCompleteDTO.prototype, "building", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item to be crafted'),
    __metadata("design:type", String)
], CraftCompleteDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity of items to be crafted'),
    __metadata("design:type", Number)
], CraftCompleteDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Time in seconds to craft item'),
    __metadata("design:type", Number)
], CraftCompleteDTO.prototype, "time", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Item, minSize: 1 }),
    (0, decorators_1.Describe)('Items (or currency) and quantities required for crafting'),
    __metadata("design:type", Array)
], CraftCompleteDTO.prototype, "recipe", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utility_1.ArrayOfType)({
        type: () => game_related_1.ProximityEffectCraftCompleteOptional,
        minSize: 1,
    }),
    (0, decorators_1.Describe)('Array of proximity effects'),
    __metadata("design:type", Array)
], CraftCompleteDTO.prototype, "proximityEffects", void 0);
CraftCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Craft Complete event')
], CraftCompleteDTO);
exports.CraftCompleteDTO = CraftCompleteDTO;
let CraftRequestDTO = class CraftRequestDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.CraftRequestDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "building", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recipe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of building where item is crafted'),
    __metadata("design:type", String)
], CraftRequestDTO.prototype, "building", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item to be crafted'),
    __metadata("design:type", String)
], CraftRequestDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity of items to be crafted'),
    __metadata("design:type", Number)
], CraftRequestDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Time in seconds to craft item'),
    __metadata("design:type", Number)
], CraftRequestDTO.prototype, "time", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Item, minSize: 1 }),
    (0, decorators_1.Describe)('Items (or currency) and quantities required for crafting'),
    __metadata("design:type", Array)
], CraftRequestDTO.prototype, "recipe", void 0);
CraftRequestDTO = __decorate([
    (0, decorators_1.Describe)('Craft Request event')
], CraftRequestDTO);
exports.CraftRequestDTO = CraftRequestDTO;
let HarvestCompleteDTO = class HarvestCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.HarvestCompleteDTO, [gal_reporting_groups_1.GalReportingGroups.product, gal_reporting_groups_1.GalReportingGroups.townstar]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "building", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item'),
    __metadata("design:type", String)
], HarvestCompleteDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of item harvested'),
    __metadata("design:type", Number)
], HarvestCompleteDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Time of harvest in seconds'),
    __metadata("design:type", Number)
], HarvestCompleteDTO.prototype, "time", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of building or object from which the item was harvested'),
    __metadata("design:type", String)
], HarvestCompleteDTO.prototype, "building", void 0);
HarvestCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Harvest Complete event')
], HarvestCompleteDTO);
exports.HarvestCompleteDTO = HarvestCompleteDTO;
let ProductionCompleteDTO = class ProductionCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ProductionCompleteDTO, [gal_reporting_groups_1.GalReportingGroups.product, gal_reporting_groups_1.GalReportingGroups.townstar]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "building", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "proximityEffects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item'),
    __metadata("design:type", String)
], ProductionCompleteDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of item produced'),
    __metadata("design:type", Number)
], ProductionCompleteDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Time of production in seconds'),
    __metadata("design:type", Number)
], ProductionCompleteDTO.prototype, "time", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of building or object that produced the item'),
    __metadata("design:type", String)
], ProductionCompleteDTO.prototype, "building", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.ProximityEffectOptional, minSize: 1 }),
    (0, decorators_1.Describe)('Array of proximity effects'),
    __metadata("design:type", Array)
], ProductionCompleteDTO.prototype, "proximityEffects", void 0);
ProductionCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Production Complete event')
], ProductionCompleteDTO);
exports.ProductionCompleteDTO = ProductionCompleteDTO;
let RankingDTO = class RankingDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.RankingDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "chartName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "score", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of chart'),
    __metadata("design:type", String)
], RankingDTO.prototype, "chartName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Frequency chart is updated'),
    __metadata("design:type", String)
], RankingDTO.prototype, "interval", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Score'),
    __metadata("design:type", Number)
], RankingDTO.prototype, "score", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Current rank'),
    __metadata("design:type", Number)
], RankingDTO.prototype, "rank", void 0);
RankingDTO = __decorate([
    (0, decorators_1.Describe)('Ranking event')
], RankingDTO);
exports.RankingDTO = RankingDTO;
let StorageFlushDTO = class StorageFlushDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.StorageFlushDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of storage object or building'),
    __metadata("design:type", String)
], StorageFlushDTO.prototype, "store", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.ItemOptional, minSize: 1 }),
    (0, decorators_1.Describe)('Array of items flushed from storage'),
    __metadata("design:type", Array)
], StorageFlushDTO.prototype, "items", void 0);
StorageFlushDTO = __decorate([
    (0, decorators_1.Describe)('Storage Flush event')
], StorageFlushDTO);
exports.StorageFlushDTO = StorageFlushDTO;
let StoreDTO = class StoreDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.StoreDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "building", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantityRejected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transportTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.StorageSuccess),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Success of attempted storage'),
    __metadata("design:type", String)
], StoreDTO.prototype, "success", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of storage building'),
    __metadata("design:type", String)
], StoreDTO.prototype, "building", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item being stored'),
    __metadata("design:type", String)
], StoreDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of item being stored'),
    __metadata("design:type", Number)
], StoreDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity of item rejected from being stored'),
    __metadata("design:type", Number)
], StoreDTO.prototype, "quantityRejected", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Time in seconds taken to transport item to storage'),
    __metadata("design:type", Number)
], StoreDTO.prototype, "transportTime", void 0);
StoreDTO = __decorate([
    (0, decorators_1.Describe)('Store event')
], StoreDTO);
exports.StoreDTO = StoreDTO;
let TradeDTO = class TradeDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.TradeDTO, [
    gal_reporting_groups_1.GalReportingGroups.product,
    gal_reporting_groups_1.GalReportingGroups.townstar,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "cost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "costCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "receivables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Any cost associated with performing trade'),
    __metadata("design:type", Number)
], TradeDTO.prototype, "cost", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency of trade cost'),
    __metadata("design:type", String)
], TradeDTO.prototype, "costCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item'),
    __metadata("design:type", String)
], TradeDTO.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of item traded'),
    __metadata("design:type", Number)
], TradeDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.ItemOptional, minSize: 1 }),
    (0, decorators_1.Describe)('Array of receivable items from the trade'),
    __metadata("design:type", Array)
], TradeDTO.prototype, "receivables", void 0);
TradeDTO = __decorate([
    (0, decorators_1.Describe)('Trade event')
], TradeDTO);
exports.TradeDTO = TradeDTO;
